import React, { useEffect, useState } from "react";
import "./Hajj.css";
import { DefaultPlayer as Video } from "react-html5video";
import "react-html5video/dist/styles.css";
import { Link } from "react-router-dom";

const Hajj = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  setTimeout(() => {
    var bodyWidth = document.querySelector("body").clientWidth;
    var hajjVideo = document.querySelector(".hajj-video");
    if (bodyWidth < 800) {
      hajjVideo.querySelector(
        ".rh5v-DefaultPlayer_component"
      ).style.width = `${bodyWidth}px`;
    }
  }, 1000);

  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");
    var fr = document.querySelector("body").getAttribute("class");

    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else if (fr.includes("fr")) {
        setFr(true);
      } else {
        setRtl(false);
        setFr(false);
      }
    }
  }, []);
  return (
    <div class="bg-image">
      <div class="top-hajj">
        <div>
          <h1>
            {rtl
              ? `وكالة الحج والعمرة للمسلمين`
              : fr
              ? "AGENCE DU HAJJ ET DE L'OMRAH POUR LES MUSULMANS"
              : `Hajj & Umrah agency for Muslims`}
          </h1>
          <p style={{ width: "73%" }}>
            {rtl
              ? `مرحبا بكم في وكالة الحج والعمرة للمسلمين ، إنه مكان للمجتمع المسلم لتحديث
معرفتهم وغير المسلمين لمعرفة الإسلام وجميع الأماكن الإسلامية في جميع أنحاء
العالم.`
              : fr
              ? `Bienvenue dans notre agence Hajj & Omrah pour les
              musulmans. C'est un lieu où la communauté musulmane peut
              rafraîchir ses connaissances et où les non-musulmans peuvent
              s'informer sur l'islam et tous les lieux islamiques du monde.`
              : ` Welcome to our Hajj & Umrah agency for Muslims , It’s a
                        place for the Muslim community to refresh their
                        knowledge and non-muslims to know about Islam and all
                        Islamic places around the world.`}
          </p>
        </div>

        <img
          src={require("../../../Assets/images/Hajj-umrah.png")}
          // class="prx"
          style={{ width: "47%" }}
        />
      </div>
      <section style={{ marginBottom: "60px" }}>
        <div class="pilgrimage-fbloc">
          <div class="Hajj-bloc">
            {/* <h1>Pilgrimage (Hajj)</h1> */}
            {/* <p>
                            Welcome to our Hajj & Umrah agency for Muslims ,
                            It’s a place for the Muslim community to refresh
                            their knowledge and non-muslims to know about Islam
                            and all Islamic places around the world.
                        </p> */}
          </div>
        </div>
        <div class="bottom-bloc">
          <div class="Hajj-bloc Hajj-text">
            <p>
              {rtl
                ? `إنه يخلق الوعي حول نمط الحياة الإسلامية وكذلك تعاليم النبي محمد (صلى الله عليه
وسلم).`
                : fr
                ? `Elle sensibilise au mode de vie islamique et aux enseignements du
                prophète Mohamed (s.a.w).`
                : `It creates awareness about the Islamic lifestyle and
                            also the teachings of the prophet Muhammad(s.a.w).`}
            </p>
            <p>
              {rtl
                ? `سيكون بيت الحج داخل مصرفنا الاستثماري الإسلامي أكثر فائدة وتوجيها لهم لأداء
العمرة والحج.`
                : fr
                ? `La maison du Hajj au sein de notre banque d'investissement islamique
                leur sera plus utile et les guidera dans l'accomplissement de l'Omrah et
                du Hajj.`
                : `The Hajj house inside our Islamic investment bank
                            will be more helpful and guidance for them to
                            perform Umrah and Hajj.`}
            </p>
            <p>
              {rtl
                ? `سنقوم بإنشاء منصة عبر الإنترنت مخصصة لمساعدة الحجاج الذين يخططون لأداء
فريضة الحج والعمرة.`
                : fr
                ? `Nous allons créer une plateforme en ligne destinée à aider les pèlerins
                qui prévoient d'accomplir le Hajj et l'Omrah.`
                : ` We will create an online platform dedicated to
                            assisting pilgrims planning to perform Hajj and
                            Umrah.`}
            </p>
            <p>
              {rtl
                ? `يوفر موقع الحج والعمرة على شبكة الإنترنت وصفا شاملا لجميع جوانب الحج
والعمرة ، رحلة العمر.`
                : fr
                ? `Le site Web du Hajj et de la Omrah offre un compte rendu complet de
                tous les aspects du Hajj et de l'Omrah, le voyage d'une vie.`
                : `Hajj & Umrah web site provides a comprehensive
                            account of all aspects of the Hajj and Umrah, the
                            journey of a lifetime.`}
            </p>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              width: "39%",
            }}
            class="hajj-bloc-images"
          >
            <div class="image-overlay">
              <img
                src={require("../../../Assets/images/hajj-1.jpg")}
                alt="Hajj"
                class="Hajj-makkah"
              />
              {/* <div class="i-overlay"></div> */}
            </div>
            <div class="image-overlay">
              <img
                src={require("../../../Assets/images/hajj-s.jpg")}
                alt="Hajj"
                class="Hajj-makkah"
              />
              {/* <div class="i-overlay"></div> */}
            </div>
          </div>
        </div>
      </section>
      <div class="hajj-video">
        <Video
          // autoPlay
          // loop
          muted
          controls={["PlayPause", "Seek", "Time", "Volume", "Fullscreen"]}
          poster={require("../../../Assets/images/video-capture.png")}
          onCanPlayThrough={() => {
            // Do stuff
          }}
        >
          <source
            src={require("../../../Assets/Hajj-video.mp4")}
            type="video/mp4"
          />
          <track
            label="English"
            kind="subtitles"
            srcLang="en"
            src="http://source.vtt"
            default
          />
        </Video>
      </div>
      <div class="container">
        <div class="plrs-wrap text-center remove-ext5">
          <div
            class="row"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div class="col-md-3 col-sm-6 col-lg-2 plrs ">
              <Link to="/five-pillars-shahada">
                <div class="plr-box ">
                  <i class="flaticon-clicker"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `الشهادتان` : `Shahadah`}</h4>
                    <p>({rtl ? `ايمان` : fr ? "La foi" : `Faith`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-prayer">
                <div class="plr-box">
                  <i class="flaticon-islamic-pray"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `إقامِ الصلاةِ` : `Salah`}</h4>
                    <p>({rtl ? `صلاة` : fr ? "Prière" : `Prayer`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-fasting">
                <div class="plr-box">
                  <i class="flaticon-islamic-ramadan"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `صومِ رمضانَ` : `Sawm`}</h4>
                    <p>({rtl ? `صوم` : fr ? "Le jeûne" : `Fasting`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 plrs">
              <Link to="/five-pillars-zakat">
                <div class="plr-box">
                  <i class="flaticon-charity"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `إيتاءِ الزّكاةِ` : `Zakat`}</h4>
                    <p>({rtl ? `الصدقة` : fr ? "L'aumône" : `Almsgiving`})</p>
                  </div>
                </div>
              </Link>
            </div>
            <div class="col-md-3 col-sm-6 col-lg-2 ">
              <Link to="/five-pillars-pilgrimage">
                <div class="plr-box">
                  <i class="flaticon-kaaba-building"></i>
                  <div class="pilr-info">
                    <h4>{rtl ? `الحجِّ` : `Hajj`}</h4>
                    <p>({rtl ? `حج` : fr ? "Pèlerinage" : `Pilgrimage`})</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hajj;
